// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './axios'
Vue.prototype.$axios = axios
import lang from './utils/i18n.js'

import ElementUI from 'element-ui';
Vue.use(ElementUI);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2, {
  confirmButtonColor: '#8cd4f5',
  cancelButtonColor: '#ff7674',
});

Vue.prototype.$t = function (text) {
  if (store.state.i18n == 'zh_CN') {
    return text;
  } else {
    if (lang.hasOwnProperty(text)) {
      return lang[text][store.state.i18n];
    } else {
      console.log(text + '不存在' + store.state.i18n + '翻译');
      return 'undefined';
    }
  }
}

Vue.prototype.$time = function (timestamp, string = 'Y-m-d H:i:s') {
  var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear();
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var D = date.getDate();
  var h = date.getHours();
  var m = date.getMinutes();
  var s = date.getSeconds();
  if (D < 10) {
    D = '0' + D;
  }

  if (h < 10) {
    h = '0' + h;
  }
  if (m < 10) {
    m = '0' + m;
  }

  if (s < 10) {
    s = '0' + s;
  }
  var string = string.replace('Y', Y);//年
  var string =  string.replace('m', M);//月
  var string =  string.replace('d', D);//日
  var string =  string.replace('H', h);//时
  var string =  string.replace('i', m);//分
  var string =  string.replace('s', s);//秒

  return  string;//年
  

};

Vue.prototype.$checkMyAuth = function (name) {
  if (store.state.auth.indexOf(name) == -1) {
    return false;
  } else {
    return true;
  }
};

Vue.prototype.$getMonth = function (field) {
  if (field == 'start') {
    var date = new Date();
    date.setDate(1);
  } else {
    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var date = new Date(nextMonthFirstDay - oneDay);
  };

  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate();
  if (D < 10) {
    D = '0' + D;
  }
  return Y + M + D;



};


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js